import moment from "moment"

/* Hour offsets shown in the picker: UTC-11 … UTC+12 */
export const OFFSETS = Array.from({ length: 24 }, (_, i) => i - 11)

/* Whole-hour offset of the user's device, e.g. +5 */
export const deviceOffsetHours = () => Math.round(-new Date().getTimezoneOffset() / 60)

/* Currently selected offset in hours (from cache, fallback to device) */
export const currentOffsetHours = () => {
    const stored = localStorage.getItem("timezone")
    return stored !== null && stored !== "" ? parseInt(stored, 10) : deviceOffsetHours()
}

/* "+05:00" / "-03:00" / "+00:00" — format for SQL CONVERT_TZ */
export const formatOffset = (hours) => {
    const sign = hours < 0 ? "-" : "+"
    return `${sign}${String(Math.abs(hours)).padStart(2, "0")}:00`
}

/* Offset string of the current selection for API requests */
export const apiOffset = () => formatOffset(currentOffsetHours())

/* "UTC" / "UTC +5" / "UTC -3" */
export const offsetLabel = (hours) => {
    if (hours === 0) return "UTC"
    return `UTC ${hours > 0 ? "+" : "-"}${Math.abs(hours)}`
}

/* Compact label for the minimized sidebar: "UTC" / "+5" / "-3" */
export const offsetShort = (hours) => {
    if (hours === 0) return "UTC"
    return `${hours > 0 ? "+" : "-"}${Math.abs(hours)}`
}

/* Current wall-clock time in the given offset, "HH:mm" */
export const timeAt = (hours) => moment().utcOffset(hours * 60).format("HH:mm")

/* "now" as a moment in the SELECTED offset — build date ranges in the chosen timezone,
   NOT in the viewer's machine timezone. Guarantees the same window for every viewer
   who selected the same timezone, regardless of their OS clock/zone. */
export const nowInTz = () => moment().utcOffset(currentOffsetHours() * 60)

/* Момент из БД (UTC) в ВЫБРАННОЙ зоне — чтобы показ совпадал с фильтрами по дате */
export const inTz = (value) => moment(value).utcOffset(currentOffsetHours() * 60)

/* Стенные часы ВЫБРАННОЙ зоны -> абсолютный момент ISO ("2026-08-12T18:00:00.000Z").
   Пикер отдаёт Date, у которого стенные часы уже равны часам выбранной зоны (см. wallNow),
   поэтому часы оставляем как есть и просто объявляем им нужный offset. Уходит однозначное
   значение: пересчитать его второй раз на сервере уже невозможно. */
export const wallToUtc = (value) => moment(value).utcOffset(currentOffsetHours() * 60, true).toISOString()

/* Обратное к wallToUtc: момент из БД (UTC) -> Date со стенными часами ВЫБРАННОЙ зоны.
   Именно такой Date ждёт пикер: он рисует часы в зоне браузера, а нам нужны часы панели. */
export const utcToWall = (value) => moment(inTz(value).format("YYYY-MM-DD HH:mm:ss"), "YYYY-MM-DD HH:mm:ss").toDate()
